// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let CaseV3Api = class CaseV3Api {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @summary Get list of allowed Case Statuses by Program and Case Type identifiers
     * @param caseTypeId Case Type identifier
     * @param x_program_id The program id from the list of allowed program ids
     */
    async allowedCaseStatusGetByProgramId(caseTypeId, x_program_id) {
        const _url_ = '/case/v3/AllowedCaseStatus/{caseTypeId}'
            .replace('{' + 'caseTypeId' + '}', encodeURIComponent(String(caseTypeId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'caseTypeId' is not null or undefined
        if (caseTypeId === null || caseTypeId === undefined) {
            throw new Error('Required parameter caseTypeId was null or undefined when calling allowedCaseStatusGetByProgramId.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "number");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CaseAllowedCaseStatusModels");
        }
        return response;
    }
    /**
     *
     * @summary Get list of all available Case Types.
     * @param surveyId
     */
    async caseTypeGet(surveyId) {
        const _url_ = '/case/v3/CaseType';
        let _params_ = {};
        let _headers_ = {};
        if (surveyId !== undefined) {
            _params_['surveyId'] = Serializer.serialize(surveyId, "number");
        }
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CaseTypeModels");
        }
        return response;
    }
    /**
     *
     * @summary Get list of available Case Type Statuses by Program and Case Type identifiers.
     * @param caseTypeId Case Type identifier
     * @param x_program_id The program id from the list of allowed program ids
     */
    async caseTypeStatusGetByProgramId(caseTypeId, x_program_id) {
        const _url_ = '/case/v3/CaseTypeStatus/{caseTypeId}'
            .replace('{' + 'caseTypeId' + '}', encodeURIComponent(String(caseTypeId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'caseTypeId' is not null or undefined
        if (caseTypeId === null || caseTypeId === undefined) {
            throw new Error('Required parameter caseTypeId was null or undefined when calling caseTypeStatusGetByProgramId.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "number");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CaseTypeStatusModels");
        }
        return response;
    }
    /**
     *
     * @summary Get a generic Case
     * @param caseId
     */
    async genericCaseGet(caseId) {
        const _url_ = '/case/v3/GenericCase/{caseId}'
            .replace('{' + 'caseId' + '}', encodeURIComponent(String(caseId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'caseId' is not null or undefined
        if (caseId === null || caseId === undefined) {
            throw new Error('Required parameter caseId was null or undefined when calling genericCaseGet.');
        }
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CaseGenericCaseModelResponse");
        }
        return response;
    }
    /**
     *
     * @summary Get list of available Program Case Types by Program identifier.
     * @param x_program_id The program id from the list of allowed program ids
     */
    async programCaseTypeGetByProgramId(x_program_id) {
        const _url_ = '/case/v3/ProgramCaseType';
        let _params_ = {};
        let _headers_ = {};
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "number");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CaseProgramCaseTypeModels");
        }
        return response;
    }
};
CaseV3Api = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], CaseV3Api);
export { CaseV3Api };
//# sourceMappingURL=caseV3Api.js.map